export const cilText = ["24 24","<path d='M3.375 4.125v3.75h3v-2.25h4.125v13.125h-2.625v1.5h8.25v-1.5h-2.625v-13.125h4.125v2.25h3v-3.75h-17.25z'></path>"]